import React from 'react';

import { useGetIssuersList } from 'lib/hooks/queries/eprescribe/useGetIssuersList';
import { useGetLicenseTypes } from 'lib/hooks/queries/license/useGetLicenseTypes';

import DateInputPicker from 'components/shared/DateInputPicker/DateInputPicker';
import Input from 'components/shared/Input/Input';
import Select from 'components/shared/Select/Select';

const LicenseForm = ({ formik }) => {
  const { data } = useGetIssuersList();
  const { data: licenseTypes } = useGetLicenseTypes();

  const issuersOptions = data?.issuers?.map((i) => ({ label: i.name, value: i.id })) || [];
  const licenseOptions = licenseTypes?.licenses?.map((l) => ({ label: l.name, value: l.id })) || [];

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="grid w-full grid-cols-2 gap-4">
        <Select
          label="License type"
          inputId="license-type"
          options={licenseOptions}
          placeholder="Select license type"
          onChange={(v) => {
            formik.setFieldValue('license_id', v.value);
            formik.setFieldValue('kind', v.label);
          }}
          value={licenseOptions.find((o) => o.value === formik.values.license_id) ?? null}
          required
          error={formik.touched.license_id && formik.errors.license_id}
          isMulti={false}
        />
        <Select
          label="License issuer"
          inputId="license-issuer"
          options={issuersOptions}
          placeholder="Select license issuer"
          onChange={(v) => {
            formik.setFieldValue('issuer_id', v.value);
            formik.setFieldValue(
              'state_id',
              data?.issuers?.find((i) => i.id === v.value)?.state_id ?? null
            );
          }}
          value={issuersOptions.find((o) => o.value === formik.values.issuer_id) ?? null}
          error={formik.touched.issuer_id && formik.errors.issuer_id}
          required
          isMulti={false}
        />
      </div>
      <div className="grid w-full grid-cols-2 gap-4">
        <Input
          data-qa="license-number"
          label="License number"
          placeholder="Enter license number (alphanumeric only)"
          name="license_number"
          value={formik.values.license_number}
          onChange={formik.handleChange}
          error={formik.touched.license_number && formik.errors.license_number}
          required
        />
        <DateInputPicker
          label="License expiration date"
          value={formik.values.expired_on}
          onChange={(date) => formik.setFieldValue('expired_on', date)}
          isClearable={false}
          required
          minDate={new Date()}
          placeholder="MM / DD / YYYY"
        />
      </div>
    </div>
  );
};

export default LicenseForm;
